export default __webpack_public_path__ + "static/media/Pattern_03.387b7284.png";